import { useApolloClient } from '@apollo/client';
import { MenuItem } from '@material-ui/core';
import gql from 'graphql-tag';
import React from 'react';
import { getSecondary } from '../../styles/colors';
import { BasicButton, Radio, SelectInput } from '../../UI';
import CheckBox from '../../UI/CheckBox';
import FormRootLayout from './FormRootLayout';

const ConfigLanguage = ({ portal, updateState, translate }) => {
	const [localState, setLocalState] = React.useState((portal && portal.config.languages) || {});
	const [languages, setLanguages] = React.useState({});
	const client = useApolloClient();

	const getLang = React.useCallback(async () => {
		const response = await client.query({
			query: gql`
			query languages {
				languages {
					desc
					columnName
				}
			}`,
		});
		if (response.data) {
			let LanguagesTransform = {};

			Object.values(response.data.languages).forEach(el => {
				LanguagesTransform = {
					...LanguagesTransform,
					[el.columnName]: el.desc
				};
			});
			setLanguages(LanguagesTransform);
		}
	}, [portal, languages]);

	React.useEffect(() => {
		getLang();
	}, []);

	const renderForm = () => (
		<div>

			<div style={{
				display: 'flex',
				alignItems: 'center',
				gap: '1rem'
			}}>
				<div style={{}}>
					<div style={{ margin: '0' }}><b>Idioma por defecto:</b></div>
				</div>
				<div>
					{
						<SelectInput
							value={localState.default}
							disableUnderline={true}
							styles={{
								margin: '0px',
								marginTop: '9px',
								paddingTop: 0,
								paddingBottom: '0'
							}}
							onChange={ev => {
								setLocalState({
									...localState,
									default: ev.target.value
								});
							}}>
							{Object.entries(languages).map(([key, value]) => (
								<MenuItem key={value} value={key}>
									{value}
								</MenuItem>
							))
							}
						</SelectInput>
					}
				</div>
			</div>
			<div style={{ marginTop: '20px' }}>
				<div><b>Tipo de visualización:</b></div>
			</div>
			<div style={{ marginBottom: '20px' }}>
				<Radio
					name="displayType"
					checked={localState.displayType === 'flag'}
					label={'Banderas'}
					onChange={() => {
						setLocalState({
							...localState,
							displayType: 'flag'
						});
					}} />
				<Radio
					name="displayType"
					checked={localState.displayType === 'initials'}
					label={'Iniciales'}
					onChange={() => {
						setLocalState({
							...localState,
							displayType: 'initials'
						});
					}} />
			</div>
			<div style={{ marginTop: '1em' }}>
				<div style={{ marginRight: '.5em' }}>
					<div style={{}}><b>Otros idiomas:</b></div>
				</div>
			</div>
			<div >
				<Radio
					name="languages"
					checked={localState.isActive === true}
					label={'Activar'}
					onChange={() => {
						setLocalState({
							...localState,
							isActive: true
						});
					}} />
				<Radio
					name="languages"
					checked={localState.isActive === false}
					label={'Desactivar'}
					onChange={() => {
						setLocalState({
							...localState,
							isActive: false,
							language:
							{
								es: {
									value: 'es',
									label: 'Español',
									text: {},
								},
								en: {
									value: 'en',
									label: 'English',
									text: {},
								},
							}
						});
					}} />
			</div>
			{localState.isActive &&
				<div>
					<div>
						{
							Object.entries(languages).map(([key, value]) => (
								<CheckBox
									key={value}
									label={value}
									value={!!((localState && localState.language[key]) && localState.language[key].value === key)}
									onChange={(ev, isInputChecked) => {
										if (isInputChecked) {
											setLocalState({
												...localState,
												language: {
													...localState.language,
													[key]: {
														value: key,
														label: value,
														text: {},
													},
												}
											});
										} else {
											const { language } = localState;
											const { [key]: langCode, ...newLanguage } = language;
											setLocalState({ ...localState, language: newLanguage });
										}
									}} />
							))
						}
					</div>
				</div>
			}
		</div>
	);

	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateState({
							languages: localState
						});
					}}
					backgroundColor={{
						backgroundColor: getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};


export default ConfigLanguage;
